import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { mistakeMessage } from "./container";
import { ChokkankunIcon } from "../icons/ChokkankunIcon";

const MistakeModal: React.FC<{}> = () => {
  const [chokkankunWidth, setChokkankunWidth] = useState<number>(0);
  const [chokkankunHeight, setChokkankunHeight] = useState<number>(0);
  const [charWidth, setCharWidth] = useState<number>(0);
  const [charHeight, setCharHeight] = useState<number>(0);

  const getSizes = () => {
    const elMistake = document.getElementById("mistakeChar0");
    const elChar = document.getElementById("char0");
    setChokkankunWidth(elMistake?.getBoundingClientRect().width || 0);
    setChokkankunHeight(elMistake?.getBoundingClientRect().height || 0);
    setCharWidth(elChar?.getBoundingClientRect().width || 0);
    setCharHeight(elChar?.getBoundingClientRect().height || 0);
  };

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      getSizes();
      window.addEventListener("resize", getSizes);
      return () => window.removeEventListener("resize", getSizes);
    }

    return;
  }, []);

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            zIndex: 2,
            width: "100%",
            height: "40%",
          }}
        >
          <Box
            display="flex"
            mt="auto"
            mb="auto"
            ml="auto"
            mr="auto"
            sx={{
              width: { xs: "90%", md: "35%" },
            }}
          >
            {mistakeMessage.map((char, index) => (
              <Box
                id={"mistakeChar" + index}
                width="20%"
                position="relative"
                key={index}
              >
                <ChokkankunIcon
                  width="100%"
                  colorIndex={index}
                  style={{
                    animation: "mistake 2s ease infinite",
                    objectFit: "contain",
                  }}
                />
                <Box
                  id={"char" + index}
                  style={{
                    position: "absolute",
                    top: chokkankunHeight / 2 - charHeight / 2,
                    left: chokkankunWidth / 2 - charWidth / 2,
                    transform: "translate(-50%, -50%)", //意味わかってない気がするので確認要
                    animation: "mistake 2s ease infinite",
                    fontFamily: "yasashisa",
                  }}
                  sx={{
                    color: "black",
                    fontSize: { xs: 25, md: 45 },
                  }}
                >
                  {char}
                </Box>
              </Box>
            ))}
          </Box>
        </div>
      </div>
    </>
  );
};

export default MistakeModal;
